import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { resignFormFailed, resignFormSucceed } from '../store/actions';
import { getResignFormData } from '../store/selectors';

export function useResignPayment() {
  const dispatch = useDispatch();

  const resignFormData = useSelector(getResignFormData);

  const doResignFormSucceed = useCallback(() => {
    dispatch(resignFormSucceed());
  }, [dispatch]);

  const doResignFormFailed = useCallback(() => {
    dispatch(resignFormFailed());
  }, [dispatch]);

  return {
    resignFormData,
    resignFormSucceed: doResignFormSucceed,
    resignFormFailed: doResignFormFailed,
  };
}
